@if (readStatus()) {
  <div class="border border-gray-200 rounded-lg p-6 bg-white">
    <div class="mb-6">
      <div class="field-label">Data opublikowania</div>
      <div class="field-value">
        {{ readStatus()!.publishedAt | date: 'yyyy-MM-dd HH:mm:ss' }}
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      @if (shouldShowEmailStats()) {
        <div>
          <div class="field-label flex items-center gap-2">
            Liczba wysłanych wiadomości e-mail
            <i
              class="pi pi-info-circle text-gray-500"
              pTooltip="Liczba wysłanych wiadomości e-mail (Liczba wiadomości e-mail, które powinny być wysłane)"
              tooltipPosition="top"
            ></i>
          </div>
          <div class="field-value">{{ emailStatsLabel }}</div>
        </div>
      }
      @if (shouldShowSystemStats()) {
        <div>
          <div class="field-label">
            Liczba użytkowników, którzy odczytali komunikat
          </div>
          <div class="field-value">{{ readStatus()!.readUsersCount }}</div>
        </div>
        <div>
          <div class="field-label">
            Procent użytkowników, którzy odczytali komunikat
          </div>
          <div class="field-value">{{ readStatus()!.readUsersPercent }}%</div>
        </div>
      }
    </div>
  </div>

  <div class="flex justify-end mt-6">
    <p-button
      label="Zamknij"
      styleClass="customInfoButton outlined"
      (click)="close()"
    />
  </div>
}
